// extracted by mini-css-extract-plugin
export default {"Backdrop":"BackDrop_Backdrop__A-jL3"};